const COMPONENT_NAME = "OpeningHours";
const COMPOSABLE_DATA_OPEN_UNTIL = "openUntil";
const COMPOSABLE_DATA_CLOSED_UNTIL = "closedUntil";
const COMPOSABLE_DATA_CLOSED = "closed";
const COMPOSABLE_DATA_CLOSED_FOR_HOLIDAY = "closedForHoliday";
const COMPOSABLE_DATA_CLOSED_FOR_EMERGENCY = "closedForEmergency";
const COMPOSABLE_DATA_REASON = "{reason}";
const COMPOSABLE_DATA_GOLD_HOURS_START_AT = "openForGoldAt";
const COMPOSABLE_DATA_EXEC_HOURS_START_AT = "openForExecutiveAt";
const COMPOSABLE_DATA_OPEN_FOR_EXEC = "openForExecutive";
const COMPOSABLE_DATA_CLOSING_TIME = "{closingTime}";
const COMPOSABLE_DATA_OPENING_TIME = "{openingTime}";
const COMPOSABLE_DATA_OPENING_DAY = "{openingDay}";
const UNIQUE_ID = "warehouse-openinghours";
export {
  COMPONENT_NAME,
  COMPOSABLE_DATA_CLOSED,
  COMPOSABLE_DATA_CLOSED_FOR_EMERGENCY,
  COMPOSABLE_DATA_CLOSED_FOR_HOLIDAY,
  COMPOSABLE_DATA_CLOSED_UNTIL,
  COMPOSABLE_DATA_CLOSING_TIME,
  COMPOSABLE_DATA_EXEC_HOURS_START_AT,
  COMPOSABLE_DATA_GOLD_HOURS_START_AT,
  COMPOSABLE_DATA_OPENING_DAY,
  COMPOSABLE_DATA_OPENING_TIME,
  COMPOSABLE_DATA_OPEN_FOR_EXEC,
  COMPOSABLE_DATA_OPEN_UNTIL,
  COMPOSABLE_DATA_REASON,
  UNIQUE_ID
};
